import { Constants, musicVolume, effectsVolume, videoVolume, setMusicVolume, setEffectsVolume, setVideoVolume, virtualWheel } from "@core/Utils/Constants";
import { Scene } from "phaser";
import { MenuSettings } from "./MenuSettings";
import { Language, Messages } from '@core/GUI/Language';
import { BaseRouletteMainScene } from "BaseRoulette/Sources/Scenes/BaseRouletteMainScene";

export class MenuVolumeSettings extends MenuSettings {

    private musicVolumeText: Phaser.GameObjects.Text;
    private musicVolumeSlider: Phaser.GameObjects.Image;
    private musicSelectedIndex: number

    private effectsVolumeText: Phaser.GameObjects.Text;
    private effectsVolumeSlider: Phaser.GameObjects.Image;

    private videoVolumeText: Phaser.GameObjects.Text;
    private videoVolumeSlider: Phaser.GameObjects.Image;

    constructor(scene: Scene, text: string, spriteSheet: string, icon: string, buttonHeightMultiplier: number, sliderImage: string, private hasVideoVolume: boolean = false) {
        super(scene, text, spriteSheet, icon, buttonHeightMultiplier);
        //-----------music volume-----------
        this.musicSelectedIndex = 0
        this.musicVolumeText = new Phaser.GameObjects.Text(scene, 0, 0, Language.Get(Messages.SETTINGS_MUSIC_VOLUME), Constants.MENU_BUTTON_STYLE_FONT);
        this.musicVolumeText.setOrigin(0, 0.5);
        this.add(this.musicVolumeText);

        this.musicVolumeSlider = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, sliderImage);
        this.musicVolumeSlider.setOrigin(0.5);
        this.musicVolumeSlider.slider = this.scene.plugins.get('sliderplugin').add(this.musicVolumeSlider, {
            endPoints: [{
                x: this.musicVolumeSlider.x - 200,
                y: this.musicVolumeSlider.y
            },
            {
                x: this.musicVolumeSlider.x + 200,
                y: this.musicVolumeSlider.y
            }
            ],
            value: musicVolume
        });
        this.musicVolumeSlider.slider.on('valuechange', function (newValue, prevValue) {
            if (prevValue > 0.0 && newValue <= 0.0) {
                (this.scene as BaseRouletteMainScene).MuteBackgroundMusic()
            } else if (prevValue <= 0.0 && newValue > 0.0) {
                this.musicSelectedIndex++
                let mainScene = this.scene as BaseRouletteMainScene
                let index = Math.floor(this.musicSelectedIndex % mainScene.backgroundMusic.length)
                mainScene.UnmuteBackgroundMusic(index)
            } else setMusicVolume(newValue);
            if (newValue >= 1.0 || newValue <= 0.0)
                scene.game.events.emit("FADE_BACKGROUND_MUSIC", true);
        }.bind(this));
        this.add(this.musicVolumeSlider);

        this.background
            .lineStyle(3, 0xffffff, 1)
            .strokePoints(this.musicVolumeSlider.slider.endPoints);

        //---------effects volume-----------
        this.effectsVolumeText = new Phaser.GameObjects.Text(scene, 0, 0, Language.Get(Messages.SETTINGS_EFFECTS_VOLUME), Constants.MENU_BUTTON_STYLE_FONT);
        this.effectsVolumeText.setOrigin(0, 0.5);
        this.add(this.effectsVolumeText);

        this.effectsVolumeSlider = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, sliderImage);
        this.effectsVolumeSlider.setOrigin(0.5);
        this.effectsVolumeSlider.slider = this.scene.plugins.get('sliderplugin').add(this.effectsVolumeSlider, {
            endPoints: [{
                x: this.effectsVolumeSlider.x - 200,
                y: this.effectsVolumeSlider.y
            },
            {
                x: this.effectsVolumeSlider.x + 200,
                y: this.effectsVolumeSlider.y
            }
            ],
            value: effectsVolume
        });
        this.effectsVolumeSlider.slider.on('valuechange', function (newValue, prevValue) {
            setEffectsVolume(newValue);
        });
        this.add(this.effectsVolumeSlider);

        this.background
            .lineStyle(3, 0xffffff, 1)
            .strokePoints(this.effectsVolumeSlider.slider.endPoints);

        //---------video volume-----------
        this.videoVolumeText = new Phaser.GameObjects.Text(scene, 0, 0, Language.Get(Messages.SETTINGS_VIDEO_VOLUME), Constants.MENU_BUTTON_STYLE_FONT);
        this.videoVolumeText.setOrigin(0, 0.5);
        this.add(this.videoVolumeText);

        this.videoVolumeSlider = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, sliderImage);
        this.videoVolumeSlider.setOrigin(0.5);
        this.videoVolumeSlider.slider = this.scene.plugins.get('sliderplugin').add(this.videoVolumeSlider, {
            endPoints: [{
                x: this.videoVolumeSlider.x - 200,
                y: this.videoVolumeSlider.y
            },
            {
                x: this.videoVolumeSlider.x + 200,
                y: this.videoVolumeSlider.y
            }
            ],
            value: videoVolume
        });
        if (!virtualWheel && hasVideoVolume) {
            this.videoVolumeSlider.slider.on('valuechange', function (newValue, prevValue) {
                setVideoVolume(newValue);
                if (newValue >= 1.0 || newValue <= 0.0)
                    scene.game.events.emit("videoVolumeChanged", newValue);
            });
        }
        this.add(this.videoVolumeSlider);

        this.background
            .lineStyle(3, 0xffffff, 1)
            .strokePoints(this.videoVolumeSlider.slider.endPoints);
    }

    override handleUp(m, x, y, e): void {
        this.scene.game.events.emit("FADE_BACKGROUND_MUSIC", true);
        this.scene.game.events.emit("videoVolumeChanged", videoVolume);
        e.stopPropagation();
    }

    override ResizeAndMove(x: number, y: number, width: number, singleButtonHeight: number, padding: number) {
        super.ResizeAndMove(x, y, width, singleButtonHeight, padding);

        if (virtualWheel || !this.hasVideoVolume) {
            this.videoVolumeText.setStyle(Constants.MENU_BUTTON_STYLE_FONT_DISABLED);
            this.videoVolumeSlider.slider.setEnable(false);
            this.videoVolumeSlider.slider.value = 0;
        }

        this.musicVolumeText.setFontSize(singleButtonHeight / 2.9);
        this.effectsVolumeText.setFontSize(singleButtonHeight / 2.9);
        this.videoVolumeText.setFontSize(singleButtonHeight / 2.9);

        this.musicVolumeText.setPosition(padding, singleButtonHeight - padding);
        this.effectsVolumeText.setPosition(padding, this.musicVolumeText.y + this.musicVolumeText.displayHeight + padding * 2);
        this.videoVolumeText.setPosition(padding, this.effectsVolumeText.y + this.effectsVolumeText.displayHeight + padding * 2);

        let sliderStartPos = this.musicVolumeText.displayWidth + this.musicVolumeSlider.displayWidth / 2 + padding * 4;
        let sliderEndPos = this.width - this.musicVolumeSlider.displayWidth / 2 - padding * 2;

        this.musicVolumeSlider.setDisplaySize(singleButtonHeight / 2, singleButtonHeight / 2);
        this.musicVolumeSlider.setPosition(sliderStartPos + (sliderEndPos - sliderStartPos) * this.musicVolumeSlider.slider.value, this.musicVolumeText.y);
        this.musicVolumeSlider.slider.endPoints = [{
            x: sliderStartPos,
            y: this.musicVolumeSlider.y
        },
        {
            x: sliderEndPos,
            y: this.musicVolumeSlider.y
        }
        ];

        this.background
            .lineStyle(3, 0xffffff, 1)
            .strokePoints(this.musicVolumeSlider.slider.endPoints);

        this.effectsVolumeSlider.setDisplaySize(singleButtonHeight / 2, singleButtonHeight / 2);
        this.effectsVolumeSlider.setPosition(sliderStartPos + (sliderEndPos - sliderStartPos) * this.effectsVolumeSlider.slider.value, this.effectsVolumeText.y);
        this.effectsVolumeSlider.slider.endPoints = [{
            x: sliderStartPos,
            y: this.effectsVolumeSlider.y
        },
        {
            x: sliderEndPos,
            y: this.effectsVolumeSlider.y
        }
        ];

        this.background
            .lineStyle(3, 0xffffff, 1)
            .strokePoints(this.effectsVolumeSlider.slider.endPoints);

        this.videoVolumeSlider.setDisplaySize(singleButtonHeight / 2, singleButtonHeight / 2);
        this.videoVolumeSlider.setPosition(sliderStartPos + (sliderEndPos - sliderStartPos) * this.videoVolumeSlider.slider.value, this.videoVolumeText.y);
        this.videoVolumeSlider.slider.endPoints = [{
            x: sliderStartPos,
            y: this.videoVolumeSlider.y
        },
        {
            x: sliderEndPos,
            y: this.videoVolumeSlider.y
        }
        ];

        if (!virtualWheel && this.hasVideoVolume) {
            this.background
                .lineStyle(3, 0xffffff, 1)
                .strokePoints(this.videoVolumeSlider.slider.endPoints);
        }
        else {
            this.videoVolumeSlider.setTint(0x8a8a8a);
            this.background
                .lineStyle(3, 0x8a8a8a, 1)
                .strokePoints(this.videoVolumeSlider.slider.endPoints);
        }


    }
}